import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import Loading from '../../../../../components/general/loadings/loading';
import { CaseGeneralAccountInfoProps } from './props';

export const CaseGeneralAccountInfo = ({
    loading,
    account,
}: CaseGeneralAccountInfoProps) => {
    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12}>
                <FieldText
                    label="Cuenta"
                    name="account"
                    size="small"
                    value={`(${account?.document}) ${account?.name} ${
                        account?.lastName ? account?.lastName : ''
                    }`}
                />
            </Grid>
        </Grid>
    );
};
